import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { Icons as h } from "../assets/icons.js";
import { SimilarProductItem as t } from "./SimilarProductList.js";
const I = ({
  products: m,
  isClubClient: s,
  similarProductSelect: a,
  setSimilarProductSelect: n
}) => m != null && m.length ? /* @__PURE__ */ r("section", { className: "change-order-similar-products", children: [
  /* @__PURE__ */ i("h3", { className: "title", children: "Na falta substitua por:" }),
  /* @__PURE__ */ i("div", { className: "similar-product-list", children: m.map((o) => /* @__PURE__ */ i(
    t,
    {
      isClubClient: s,
      similarProductSelect: a,
      setSimilarProductSelect: n,
      similarProduct: o
    },
    o.itemId
  )) }),
  a && /* @__PURE__ */ r(
    "button",
    {
      onClick: () => n == null ? void 0 : n({ itemId: "" }),
      className: "remove-buttom",
      children: [
        /* @__PURE__ */ i(h, { iconId: "Trash" }),
        " Remover substituto"
      ]
    }
  )
] }) : null;
export {
  I as SimilarProducts
};
